import { FailedAgreementIcon } from "icons/action/FailedIcon";
import Button from "components/form/Button";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import {
  formatCurrency,
  customerFacingPaymentError,
} from "utils/HelperFunctions";
import { useTestAttrsFactory } from "utils/testid";

type PaymentScheduledFailedProps = {
  failedReason: string;
  handleBackToStart: () => void;
  amount: any;
  date: any;
};
const PaymentScheduledFailed = ({
  failedReason,
  handleBackToStart,
  amount,
  date,
}: PaymentScheduledFailedProps) => {
  const navigate = useNavigate();
  const { clusterId: cluster_id } = useParams();
  const testAttrs = useTestAttrsFactory();
  const isFutureDated = Boolean(date) && moment(date).isAfter(moment(), "day");

  return (
    <div
      className="h-fit	w-full max-w-[640px]"
      {...testAttrs("scheduled-payment-failed", "Scheduled payment failed")}
    >
      <div className="flex flex-col justify-center items-center gap-6">
        <div className="w-full flex flex-col justify-center items-center gap-10">
          <FailedAgreementIcon aria-hidden="true" />
          <div className="w-full text-center text-xl text-txtPrimary font-medium">
            Payment plan failed
          </div>
          <div className="w-full text-center bg-bgThird py-5 px-2 text-xl text-txtParagraph mb-4">
            {isFutureDated ? (
              <>
                We couldn&apos;t verify your card for the first scheduled
                payment of{" "}
                <span className="font-bold">{formatCurrency(amount)}</span>, so
                your payment plan was not created.
              </>
            ) : (
              <>
                Your first scheduled payment of{" "}
                <span className="font-bold">{formatCurrency(amount)}</span> has
                failed.
              </>
            )}
          </div>
          <div className="w-full text-center text-txtParagraph lg:text-xl">
            {customerFacingPaymentError(failedReason) || "Payment Failed"}
          </div>
          <div>
            <Button
              text={"Update payment method"}
              className="text-base px-11"
              onClick={() => handleBackToStart()}
              {...testAttrs("update-payment-method", "Update payment method")}
            />
          </div>
        </div>
        <div className="w-full  lg:text-base text-sm text-center text-btnPrimaryActive hover:!text-btnPrimaryHover ">
          <div
            className="cursor-pointer"
            role="button"
            tabIndex={0}
            onClick={() => navigate(`/${cluster_id}/dashboard`)}
            {...testAttrs("back-to-dashboard", "Back to dashboard")}
          >
            Back to dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentScheduledFailed;
